export default "__VITE_ASSET__CucBsg77__"